import React, { useEffect } from "react";
import SearchPanel from "../components/SearchPanel";

function Main({ menuVisible, toggleMenu }) {
    /* Esc to close */
    useEffect(() => {
        if (!menuVisible) return;
        const onKey = (e) => e.key === 'Escape' && toggleMenu();
        document.addEventListener('keydown', onKey);
        return () => document.removeEventListener('keydown', onKey);
    }, [menuVisible, toggleMenu]);

    if (!menuVisible) return null;

    return (
        <div className="fixed inset-0 z-[200] flex items-start justify-center px-4 pt-[80px] md:pt-[100px]">
            {/* Backdrop */}
            <div
                onClick={toggleMenu}
                className="absolute inset-0 bg-black/60 backdrop-blur-sm"
            />
            {/* Panel */}
            <div className="relative z-10 w-full max-w-2xl">
                <SearchPanel onClose={toggleMenu} />
            </div>
        </div>
    );
}

export default Main;
